import { useFlags } from '@atlaskit/flag';
import { SpinnerMask } from '@atlassian/amkt-common';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { endPromotion, PromotionStatus } from '@atlassian/mpac-api-client';
import { useHistory, useParams } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import invariant from 'invariant';
import React, { useState } from 'react';
import PartnerHeader from "../../../../common/components/PartnerHeader";
import Tabs from "../../../../common/components/Tabs";
import { ANALYTICS_SUBJECT_ID_END_PROMOTION } from "../../../analytics/Events";
import { promotionsRoute } from "../../../constants/Routes";
import { getFlagForError } from "../../../utils/FlagUtils";
import { resolveManagePartnersRoutes } from "../../../utils/routeUtils";
import { PromotionListSectionMessageActions } from "../CreatePromotion/constants";
import { gotoPromotionsListPage } from "../CreatePromotion/PromotionBasics/PromotionBasics.utils";
import EndPromotionConfirmationModal from "../EndPromotionConfirmationModal/EndPromotionConfirmationModal";
import { Section } from "../PromotionsList/PromotionsList";
import { usePromotionDetails } from "./hooks";
import { getTabs } from "./ViewPromotionDetails.util";
import ViewPromotionDetailsRoutes from "./ViewPromotionDetailsRoutes";
export default function ViewPromotionDetails(props) {
  const {
    showFlag
  } = useFlags();
  const [selectedTab, setSelectedTab] = useState('');
  const [endPromotionConfirmModalState, setEndPromotionConfirmModalState] = useState(false);
  const history = useHistory();
  const params = useParams();
  invariant(params.promotionId, 'Promotion id is required');
  const promotionId = Number.parseInt(params.promotionId, 10);
  const fireAnalyticsEvent = useAnalyticsEvents();

  const handleEndingPromotionClick = async () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_END_PROMOTION,
      attributes: {
        partnerId: props.partnerId
      }
    });

    try {
      await endPromotion(props.mpacBaseUrl, props.partnerId, promotionId);
      setEndPromotionConfirmModalState(false);
      gotoPromotionsListPage(history, {
        partnerId: props.partnerId
      }, promotionId, PromotionListSectionMessageActions.END_PROMOTION);
    } catch (endPromotionError) {
      showFlag(getFlagForError('end-promotion-flag', 'Ending the promotion failed'));
      log.error('PromotionCodes/EndPromotionImmediately', "Failed to End Promotion Immediately", {
        endPromotionError
      });
    }
  };

  const {
    promotionDetails,
    pending,
    error
  } = usePromotionDetails(props.mpacBaseUrl, props.partnerId, promotionId);

  if (pending) {
    return /*#__PURE__*/React.createElement(SpinnerMask, {
      active: true,
      delay: 750
    });
  }

  if (error) {
    // TODO: Add the commonized error page
    return /*#__PURE__*/React.createElement(Section, null, "We ran into a little trouble. It might just be a hiccup. Try again in a bit.");
  }

  const breadcrumbs = [{
    href: resolveManagePartnersRoutes(promotionsRoute.path, {
      partnerId: props.partnerId
    }),
    text: 'Promotions'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, endPromotionConfirmModalState && /*#__PURE__*/React.createElement(EndPromotionConfirmationModal, {
    mpacBaseUrl: props.mpacBaseUrl,
    onCloseModal: () => setEndPromotionConfirmModalState(false),
    onPromotionEnd: handleEndingPromotionClick
  }), /*#__PURE__*/React.createElement(PartnerHeader, {
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    partnerDetails: props.partnerDetails,
    headerName: promotionDetails.name,
    breadcrumbs: breadcrumbs,
    showEndPromotionButton: promotionDetails.status === PromotionStatus.ACTIVE,
    promotionId: promotionId,
    openEndPromotionConfirmationModal: () => setEndPromotionConfirmModalState(true)
  }), /*#__PURE__*/React.createElement(Tabs, {
    tabs: getTabs(props.partnerId, promotionId, promotionDetails.promotionType),
    selectedTab: selectedTab
  }), /*#__PURE__*/React.createElement(ViewPromotionDetailsRoutes, {
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    promotionId: promotionId,
    promotionDetails: promotionDetails,
    selectedTab: selectedTab,
    setSelectedTab: setSelectedTab
  }));
}